module.exports = __webpack_public_path__ + "static/img/xx3.8ad1260.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/img/txinfo/xx3.png
// module id = vFCH
// module chunks = 1